<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0" v-if="user">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
            <div class="profile-info d-sm-flex align-items-center mb-10">
                <div class="m-0">
                    <!-- <h1 class="text-black fw-medium mb-8">{{ user.firstname }} {{ user.lastname }}</h1> -->
                    <span class="d-block text-dark-emphasis mb-0 small">
                        {{ user.id }}
                    </span>
                </div>
            </div>
            <!-- <div class="border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30"></div> -->
            <div class="d-flex align-items-center justify-content-between">
                <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('form.section.personal_information') }}</h5>
                <router-link :to="{
                    path: `/user/${user.id}/edit`, query: {
                        center_id: center_id
                    }
                }" class="d-inline-block text-decoration-none lh-1 text-muted fw-medium">
                    <i class="ph-duotone ph-pencil text-black position-relative top-1 fs-16 me-1"></i>
                    {{ $t('cta.edit') }}
                </router-link>
            </div>
            <ul class="info mt-25 ps-0 mb-0 list-unstyled">
                <li class="position-relative">
                    <div class="icon text-success rounded-circle text-center">
                        <i class="ph ph-envelope-simple"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.email.label') }}</span>
                    <a :href="`mailto:${user.email}`"
                        class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
                        {{ user.email }}
                    </a>
                </li>
                <li class="position-relative">
                    <div class="icon text-warning-light rounded-circle text-center">
                        <i class="ph ph-phone"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.phone.label') }}</span>
                    <a :href="`tel:${user.phone_number}`"
                        class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none">
                        {{ user.phone_number }}
                    </a>
                </li>
                <li class="position-relative" v-if="!user.role.is_custom_role">
                    <div class="icon text-primary rounded-circle text-center">
                        <i class="ph ph-person"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.role.label') }}</span>
                    <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
                        {{ user.role.name }}
                    </span>
                </li>
                <li class="position-relative" v-if="user.role_in_department">
                    <div class="icon text-muted rounded-circle text-center">
                        <i class="ph ph-user-circle"></i>
                    </div>
                    <span class="d-block text-black mb-5 fw-semibold">{{ $t('form.role_in_department.label') }}</span>
                    <span class="d-inline-block fs-md-15 fs-lg-16 text-muted">
                        {{ user.role_in_department }}
                    </span>
                </li>
            </ul>
            <div class="mt-25 d-flex justify-content-end">
                <RecoveryPasswordButton :user_id="user.id" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import API from "@/services/api/api.service";
import { UserInfo } from "@/utils/models/user.model";
import { defineComponent } from "vue";
import RecoveryPasswordButton from "./RecoveryPasswordButton.vue";

export default defineComponent({
    name: "UserAnagraph",
    data() {
        console.log(this.$route.meta.user)
        return {
            user: this.$route.meta.user as UserInfo,
            center_id: this.$route.query.center_id as string | undefined
        }
    },
    components: {
        RecoveryPasswordButton
    },
});
</script>